var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLandscapeIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "landscape-2--photos-photo-landscape-picture-photography-camera-pictures-image"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.90819 36.155H33.0919C33.7955 36.155 34.4703 35.8754 34.9679 35.3779C35.4654 34.8803 35.7449 34.2055 35.7449 33.5019V4.31822C35.7449 3.61459 35.4654 2.93977 34.9679 2.44222C34.4703 1.94468 33.7955 1.66516 33.0919 1.66516H3.90819C3.20455 1.66516 2.52974 1.94468 2.03219 2.44222C1.53465 2.93977 1.25513 3.61459 1.25513 4.31822V33.5019C1.25513 34.2055 1.53465 34.8803 2.03219 35.3779C2.52974 35.8754 3.20455 36.155 3.90819 36.155Z",
    stroke: "#95AAC9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.8674 16.257C12.9229 16.257 13.9351 15.8378 14.6814 15.0914C15.4277 14.3451 15.847 13.3329 15.847 12.2774C15.847 11.222 15.4277 10.2098 14.6814 9.46345C13.9351 8.71713 12.9229 8.29785 11.8674 8.29785C10.812 8.29785 9.79973 8.71713 9.05341 9.46345C8.30709 10.2098 7.88782 11.222 7.88782 12.2774C7.88782 13.3329 8.30709 14.3451 9.05341 15.0914C9.79973 15.8378 10.812 16.257 11.8674 16.257Z",
    stroke: "#95AAC9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M4.57141 36.1549L23.9388 17.9019C24.1771 17.7033 24.4775 17.5946 24.7877 17.5946C25.098 17.5946 25.3984 17.7033 25.6367 17.9019L35.7449 25.1447",
    stroke: "#95AAC9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLandscapeIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/landscapeIcon.61b9375f.svg";
export { ForwardRef as ReactComponent };